module.exports = __webpack_public_path__ + "static/img/ARCHIE-VAN-DYK.e79375c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ARCHIE-VAN-DYK.jpg
// module id = eKtT
// module chunks = 0